import axios from 'axios'
import ObjToFormData from '@/assets/js/common/ObjToFormData.js'
import _ from 'lodash'

export default {
  namespaced: true,
  state: {
    points: [],
    arranged: [],
    pointTypes: []
  },

  mutations: {
    SET_DATA (state, data) {
      state.points = data

      data = JSON.parse(JSON.stringify(data))

      let test = new Array(state.pointTypes.length).fill(null).map((n, x) => {
        let active = data.find((d) => {
          return parseInt(state.pointTypes[x].id) === parseInt(d.type_id)
        })

        active = active ? active.active : false

        return {
          type: state.pointTypes[x].name,
          active,
          type_id: state.pointTypes[x].id,

          levels: new Array(10).fill(0).map((n, i) => {
            return {
              level: i + 1,
              data: data.find((d) => {
                return parseInt(d.level_id) === parseInt(i + 1) &&
                  parseInt(state.pointTypes[x].id) === parseInt(d.type_id)
              }) || { values: 0 }
            }
          })
        }
      })

      state.arranged = test
    },

    SET_TYPES (state, data) {
      state.pointTypes = data
    }
  },

  getters: {},

  actions: {
    async get ({ commit }, data) {
      let response = await axios.get('/settings/points')
      let types = await axios.get(`/points/types`)
      commit('SET_TYPES', types.data)
      commit('SET_DATA', response.data)
    },

    async update ({ commit }, { id, data }) {
      console.log(id, data)
      if (id) {
        return axios.patch(`/settings/points/${id}`, data)
      } else {
        return axios.patch(`/settings/points`, data)
      }
    },

    async create ({ commit }, data) {
      console.log(data, 'create')
      return axios.post(`/settings/points`, data)
    }
  }
}
